import React, { createRef, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import { TRANSLATIONS as translation } from '../../../../../../../utils/constant.utils';
import {
    ORFSelect
    , ORFButton as Button
    , OR_RRF_Select as Select
    , ORFSearchSuggestions as SearchSuggestions
    , ORFDropdownCheckbox
} from '../../../../../../common/forms/order-request-form.component';
import { DATA_TYPE, MAX_LENGTH, PrimarySecondaryInt as PrimarySecondary } from "./../../../../../../../constants/external-constants"
import { newCircuitSubscriptionActions } from "./../../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/new-circuit/new-circuit-subscription.reducer";
import { createRequestActions } from "./../../../../../../../store/external/request-reducer/create-request.reducer";
import { InputFieldFloatingLabel as InputField } from '../../../../../../common/custom-form/select-filter.component';
import { ChatbotActions } from "../../../../../../../store/common/chatbot/chatbot.reducer";

class NewCircuitSubscriptionForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSecondary: false,
            isBoth: false,
            disableSubmit: true
        }
    }

    componentDidMount() {
        this.formChanges(this.props);
    }

    componentDidUpdate(prevProps) {
        const { wirelineSubscriptionFormA } = this.props;
        if (JSON.stringify(prevProps.wirelineSubscriptionFormA) !== JSON.stringify(wirelineSubscriptionFormA)) {
            this.formChanges(prevProps);
        } else {
            return;
        }
    }

    formChanges = (prevProps) => {
        const { wirelineSubscriptionFormA } = this.props;
        let disable = wirelineSubscriptionFormA.vendorDetailId == 0
            || wirelineSubscriptionFormA.itemUseId == 0
            || wirelineSubscriptionFormA.circuitTypeId == 0
            || wirelineSubscriptionFormA.primarySecondaryId == 0
            || wirelineSubscriptionFormA.mrc == ""
        this.primarySecondaryChanges(wirelineSubscriptionFormA.primarySecondaryId, disable);
    }

    primarySecondaryChanges = (value, disable) => {
        const { wirelineSubscriptionFormA } = this.props;
        const {subCircuitTypeOptions} = this.props.newCircuitRequest

        if (value == PrimarySecondary.secondary) {
            disable = disable || this.props.wirelineSubscriptionFormA.btnId == 0;
            this.setState({
                isSecondary: true,
                isBoth: false,
                disableSubmit: disable
            });
        } else if (value == PrimarySecondary.both) {
            disable = disable || this.props.wirelineSubscriptionFormA.mrc2 == "";
            this.setState({
                isSecondary: false,
                isBoth: true,
                disableSubmit: disable
            });
        } else {
            this.setState({
                isSecondary: false,
                isBoth: false,
                disableSubmit: disable
            });
        } 
        
        
        if(subCircuitTypeOptions) {
            if(subCircuitTypeOptions.length !== 0 ) {
                if(wirelineSubscriptionFormA.subCircuitTypeId===0)
                {
                    this.setState({                
                        disableSubmit: true
                    });
                }              
            }
        }   
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    convertToDecimal = (value) => {
        if (typeof value === "string") return value;

        const result = (Math.round(value * 100) / 100).toFixed(2);

        return result;
    }

    render() {
        const { isSecondary, isBoth, disableSubmit } = this.state;
        const {
            //component props
            onClickCancel
            , nextAction
            , prevAction
            // form
            , wirelineSubscriptionFormA
            // reducer action
            , fetchPrimarySubscriptionByValue
            , onCategorySelect
            , onCircuitTypeSelect
            , onChangeSubCircuitType
            , onChangePrimarySecondary
            , onBTNSelect
            , onChangeMRC
            , onChangeNRC
            , onChangeMRC2
            , onChangeNRC2
            , onVenderSelect
        } = this.props;
        const { primarySubscriptionList } = this.props.createRequest;
        const { preferredVendorOptions, categoryOptions, circuitTypeOptions, subCircuitTypeOptions, primarySecondaryOptions, vendorDetails } = this.props.newCircuitRequest;

        return (
            <div>
                <Form method="post" role="form"
                    model="wirelineSubscriptionFormA"
                    onSubmit={nextAction}
                >
                    <div >
                        <Row>
                            <Col xs={12} md={12} lg={12} className='required'>
                                <Select
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('vendor')}`}
                                    options={preferredVendorOptions}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    fieldProp='.vendorDetailId'
                                    value={wirelineSubscriptionFormA.vendorDetailId}
                                    onChangeAction={onVenderSelect}  
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12} className='required'>
                                <Select
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('category')}`}
                                    options={categoryOptions}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    fieldProp='.itemUseId'
                                    value={wirelineSubscriptionFormA.itemUseId}
                                    onChangeAction={onCategorySelect}  
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12} className='required'>
                                <Select
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('circuit_type')}`}
                                    options={circuitTypeOptions}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    fieldProp='.circuitTypeId'
                                    value={wirelineSubscriptionFormA.circuitTypeId}
                                    onChangeAction={onCircuitTypeSelect}
                                    disabled={wirelineSubscriptionFormA.vendorDetailId == ''
                                        || wirelineSubscriptionFormA.itemUseId == 0
                                    }                               
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12} className={`${subCircuitTypeOptions.length == 0 ? '' : 'required'}`}>
                                <Select
                                    className="form-control"
                                    label={this.toLocaleLanguage('sub_circuit_type')}
                                    options={subCircuitTypeOptions}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    fieldProp='.subCircuitTypeId'
                                    value={wirelineSubscriptionFormA.subCircuitTypeId}
                                    onChangeAction={onChangeSubCircuitType}  
                                    disabled={wirelineSubscriptionFormA.vendorDetailId == ''
                                        || wirelineSubscriptionFormA.itemUseId == 0
                                        || wirelineSubscriptionFormA.circuitTypeId == 0
                                        || subCircuitTypeOptions.length == 0
                                    }                                 
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12} className='required'>
                                <Select
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('primary_secondary')}`}
                                    options={primarySecondaryOptions}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    fieldProp='.primarySecondaryId'
                                    value={wirelineSubscriptionFormA.primarySecondaryId}
                                    onChangeAction={onChangePrimarySecondary}    
                                    disabled={wirelineSubscriptionFormA.vendorDetailId == ''
                                        || wirelineSubscriptionFormA.itemUseId == 0
                                        || wirelineSubscriptionFormA.circuitTypeId == 0                                        
                                    }                                
                                />
                            </Col>
                        </Row>
                        {isSecondary && !isBoth ?
                            <Row>
                                <Col xs={12} md={12} lg={12} className='required custom-margin'>
                                    <SearchSuggestions
                                        value={wirelineSubscriptionFormA.btn}
                                        label={`${this.toLocaleLanguage('btn')}`}
                                        propDisplay={'CircuitCode'}
                                        options={primarySubscriptionList.length > 0 ? primarySubscriptionList : ''}
                                        onChangeAction={onBTNSelect}
                                        searchAction={fetchPrimarySubscriptionByValue}
                                        placeholder={this.toLocaleLanguage('select_placeholder')}
                                    />
                                </Col>
                            </Row> : null
                        }
                        <Row>
                            <Col xs={12} md={12} lg={12} className='custom-margin no-border'>                               
                                <InputField
                                    className="form-control required"
                                    type="text"
                                    label={`${this.toLocaleLanguage('mrc')}`}                           
                                    value={this.convertToDecimal(wirelineSubscriptionFormA.mrc)}                                         
                                    fieldProp='wirelineSubscriptionFormA.mrc'
                                    placeholder={`${this.toLocaleLanguage('enter_value_placeholder')}`}
                                    disabled={wirelineSubscriptionFormA.vendorDetailId == ''}
                                    maxLength={MAX_LENGTH.inputText}
                                    inputType={DATA_TYPE.decimal}
                                    onChangeAction={onChangeMRC}
                                    />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12} className='custom-margin no-border'>
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={this.toLocaleLanguage('nrc')}
                                    value={this.convertToDecimal(wirelineSubscriptionFormA.nrc) }
                                    fieldProp='wirelineSubscriptionFormA.nrc'
                                    onChangeAction={onChangeNRC}
                                    disabled={wirelineSubscriptionFormA.vendorDetailId == ''}
                                    placeholder={`${this.toLocaleLanguage('enter_value_placeholder')}`}
                                    maxLength={MAX_LENGTH.inputText} 
                                    inputType={DATA_TYPE.decimal}
                                />
                            </Col>
                        </Row>
                        {isBoth ?
                            <div>
                                <Row>
                                    <Col xs={12} md={12} lg={12} className="custom-margin required no-border">
                                        <InputField
                                            className="form-control required"
                                            type="text"
                                            label={`${this.toLocaleLanguage('mrc2')}`}
                                            value={this.convertToDecimal(wirelineSubscriptionFormA.mrc2) }
                                            fieldProp='wirelineSubscriptionFormA.mrc2'
                                            onChangeAction={onChangeMRC2} 
                                            disabled={wirelineSubscriptionFormA.vendorDetailId == ''}   
                                            placeholder={`${this.toLocaleLanguage('enter_value_placeholder')}`}
                                            maxLength={MAX_LENGTH.inputText}  
                                            inputType={DATA_TYPE.decimal}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12} lg={12} className="no-border">
                                        <InputField
                                            className="form-control input-field mb-0"
                                            type="text"
                                            label={this.toLocaleLanguage('nrc2')}
                                            value={this.convertToDecimal(wirelineSubscriptionFormA.nrc2)}
                                            fieldProp='wirelineSubscriptionFormA.nrc2'
                                            onChangeAction={onChangeNRC2}
                                            disabled={wirelineSubscriptionFormA.vendorDetailId == ''}
                                            placeholder={`${this.toLocaleLanguage('enter_value_placeholder')}`}
                                            maxLength={MAX_LENGTH.inputText}
                                            inputType={DATA_TYPE.decimal}
                                        />
                                    </Col>
                                </Row>
                            </div> : null
                        }
                        <div className="price-plan-total-cost-container">
                            <div className="price-plan-header">
                                <span>{this.toLocaleLanguage('capital_total_cost')}</span>
                            </div>
                            <div className="price-plan-total">
                                <span>{vendorDetails.Currency}</span>
                                <span>{wirelineSubscriptionFormA.totalCost.toFixed(2)}</span>
                            </div>
                        </div>
                        <div className="request-button-continer">
                            <div className="bottom-left">
                                <Button
                                    label={this.toLocaleLanguage('modal_close_cancel_button')}
                                    variant={"light"}
                                    action={onClickCancel}
                                    type="button"
                                />
                            </div>
                            <div className="bottom-right">
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('back')}
                                        variant={"outline-secondary"}
                                        action={prevAction}
                                    />
                                </div>
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('next_button')}
                                        variant={"primary"}
                                        type={"submit"}
                                        disabled={disableSubmit}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default connect(
    state => {
        const { newCircuitRequest, createRequest, translation } = state;
        const { wirelineSubscriptionFormA } = state.form;
        return {
            newCircuitRequest
            , wirelineSubscriptionFormA
            , createRequest
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newCircuitSubscriptionActions, createRequestActions, ChatbotActions),
            dispatch
        )
)(NewCircuitSubscriptionForm);
